import React from "react"
import { withFieldLabelAndHint } from "./field"
import type { FormElement } from "./form"

type Props = {
  id?: string
  children: React.ReactNode
} & FormElement

const ComposedFormField = ({ id, children }: Props) => {
  return (
    <div className="cobalt-ComposedFormField">
      {React.Children.toArray(children).map((child, index) => {
        if (index === 0 && React.isValidElement(child)) {
          return React.cloneElement(child, { id } as { id?: string })
        }
        return child
      })}
    </div>
  )
}

const wrappedComponent = withFieldLabelAndHint(ComposedFormField)
wrappedComponent.displayName = "ComposedField"

export { wrappedComponent as ComposedField }
